import { ApolloProvider } from "@apollo/client";
import { Layer } from "@carbon/react";
import {
  AuthModeProvider,
  FoldersViewPage,
  ImportExportAuthGuard,
  InternationalizationProvider as ImportExportInternationalizationProvider,
} from "@flaminem/import-export";

import { AppUser } from "src/authentication/appUser.ts";
import "@flaminem/import-export/dist/style.css";
import PageHeader from "src/components/PageHeader.tsx";
import PageStack from "src/components/PageStack/PageStack.tsx";
import { getImportExportApolloClient } from "src/graphql/import-export/apolloClient.ts";
import { useLocale, useT } from "src/internationalization";

export const FilesPage = () => {
  const { locale } = useLocale();
  const t = useT();

  return (
    <ApolloProvider client={getImportExportApolloClient()}>
      <AuthModeProvider authMode="bearer">
        <ImportExportAuthGuard getToken={() => AppUser.getAccessToken() ?? null}>
          <ImportExportInternationalizationProvider locale={locale}>
            <PageStack>
              <PageHeader className="mb-5">{t("webcomponent.import.files.title")}</PageHeader>
              <Layer level={1}>
                <FoldersViewPage />
              </Layer>
            </PageStack>
          </ImportExportInternationalizationProvider>
        </ImportExportAuthGuard>
      </AuthModeProvider>
    </ApolloProvider>
  );
};
